import { render, staticRenderFns } from "./MenuDrawer.vue?vue&type=template&id=8fde63e2&scoped=true"
import script from "./MenuDrawer.vue?vue&type=script&lang=js"
export * from "./MenuDrawer.vue?vue&type=script&lang=js"
import style0 from "./MenuDrawer.vue?vue&type=style&index=0&id=8fde63e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fde63e2",
  null
  
)

export default component.exports